<template>
    <StepWrapper v-if="isActiveStep(step)" :step="step">
        <div class="solutionguide__properties">
            <div v-for="property in sortedCommonProperties" class="solutionguide__property">
                <img class="solutionguide__property-icon" :src="property.icon" :alt="property.name" width="100" height="100" />
                <div class="solutionguide__property-label">{{property.name}}</div>
            </div>
        </div>
        <template v-if="sortedAdditionalProperties.length > 0">
            <p class="lead">{{ $t('property.headline2') }}</p>
            <div class="solutionguide__grid">
                <div v-for="property in sortedAdditionalProperties"
                     class="solutionguide__grid-item"
                     :class="isPropertySelected(property.id) ? 'solutionguide__grid-item--selected' : (isPropertyDisabled(property.id) ? 'solutionguide__grid-item--disabled' : '')"
                     @click="() => toggleProperty(property.id)">
                    <button class="button" @mouseleave="($event) => $event.target.blur()">
                        <img class="solutionguide__grid-icon" :src="property.icon" :alt="property.name" width="100" height="100" />
                    </button>
                    <div class="solutionguide__grid-label">
                        {{property.name}}
                    </div>
                </div>
            </div>
        </template>
        <p class="lead" v-else></p>
        <div class="button-wrapper spaced">
            <GlobalButton theme="secondary" @click="back">{{ $t('property.button.back') }}</GlobalButton>
            <GlobalButton theme="primary" @click="next">{{ $t('property.button.next') }}</GlobalButton>
        </div>
    </StepWrapper>
</template>

<script lang="ts">
    import Vue from "vue";
    import {mapGetters, mapState} from "vuex";
    import {STEP} from "../store/solutionGuideStore"
    import StepWrapper from "./step-wrapper.vue";
    import type {SolutionGuide} from "../../../../../_types/solutionguide";
    import GlobalButton from "../../../../../global/global-elements/global-button/global-button.vue";

	export default Vue.extend({
        name: "step-property",
        components: {GlobalButton, StepWrapper},
        data() {
            return {
                step: STEP.Property
            }
        },
        computed: {
            ...mapState(['segment', 'component']),
            ...mapGetters(['isActiveStep', 'isPropertySelected', 'isPropertyDisabled', 'isProductAvailable', 'getProperty', 'sortAndResolvePropertyIds']),
            sortedCommonProperties(): SolutionGuide.Property[] {
                return this.sortAndResolvePropertyIds(this.component.commonPropertyIds)
            },
            sortedAdditionalProperties(): SolutionGuide.Property[] {
                return this.sortAndResolvePropertyIds(this.component.additionalPropertyIds)
            }
        },
        methods: {
            toggleProperty(id: string) {
                if (!this.isPropertyDisabled(id)) {
                    this.$store.commit('toggleProperty', id)
                }
            },
            back() {
                this.$store.commit('back')
            },
            next() {
                this.$store.commit('next')
            }
        }
    })
</script>
